import { useMutation, UseMutationResult } from 'react-query'
import { errorAlert, loadingAlert, successAlert } from '../../../utils/alert'
import { api } from '../../api'
import { localConfig } from '../../../Configs/localConfig'
import { AxiosResponse } from 'axios'
import { PropsAbastecimento } from '../../../Views/app/abastecimento'

interface PropsPost {
  cod_veiculo: number
  cod_usuario: number
  posto: {
    posto_nome: string
    cnpj: string
    endereco: string
  }
  abastecimento: {
    odom_atual: string
    qntd_litros: string
    valor_total: string
    tipo_combustivel: number
    data: string
    hora: string
    tanque_cheio: boolean
  }
  arquivo: File | null
}

interface PropsAi {
  base64: string
  mimeType: string
  refetch: Function
}

function extractMessages(data: any): string[] {
  let messages: string[] = []

  if (Array.isArray(data)) {
    data.forEach((item) => {
      messages.push(...extractMessages(item))
    })
    return messages
  }

  if (typeof data === 'object' && data !== null) {
    if (Array.isArray(data.msg)) {
      data.msg.forEach((m: any) => {
        messages.push(...extractMessages(m))
      })
    }
    return messages
  }

  if (typeof data === 'string') {
    return [data]
  }

  return []
}

export const postAbastecimento = async (data, refetch, setLoadingButton) => {
  loadingAlert({ msg: 'Salvando...', id: 'loading' })
  const config = localConfig()

  api.defaults.headers.Acesso = config.acesso
  const response: AxiosResponse<PropsPost> = await api
    .post('/abastecimento', data, {
      params: {
        codConta: config.conta,
        codCliente: localConfig().codCliente,
      },
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })

    .then((): any => {
      successAlert('Abastecimento cadastrado com sucesso!', 5000, 'loading')
      setLoadingButton(false)
      refetch()
    })
    .catch((error) => {
      const data = error?.response?.data?.error
      console.log(error)
      const messages = extractMessages(data)

      messages.forEach((msg) => {
        errorAlert(msg, 5000, 'loading')
      })
      setLoadingButton(false)
    })

  return response
}

export const usePostAnaliseAi= (): {
  carregando_analise_ai: boolean
  mutate_analise_ai: (params: PropsAi) => void
  isSuccess_analise: boolean
  data_abastecimento_ai: any
} => {
  const mutation: UseMutationResult<Response, Error, PropsAi> = useMutation(
    async (params: PropsAi) => {
      const {
      base64,
      mimeType,
      refetch
      } = params
      
      return api
        .post(`/abastecimento/ocr-cupom?codConta=${localConfig()?.conta}&codCliente=${localConfig()?.codCliente}`, {
          base64,
          mimeType
        })
        .then((response: any) => {
          successAlert('Análise feita com sucesso!', 5000, 'loading')
          refetch?.()
          return response
        })
        .catch((error: any) => {
          if (error?.response?.data?.error[0]?.msg) {
            error.response.data.error.forEach((data) => {
              errorAlert(data?.msg[0] ?? 'Falha ao realizar análise!', 5000, 'loading')
            })
          } else {
            errorAlert(
              error.response.data.error ?? 'Falha ao realizar análise!',
              5000,
              'loading'
            )
          }

          throw error
        })
    }
  )

  return {
    carregando_analise_ai: mutation.isLoading,
    mutate_analise_ai: mutation.mutate,
    isSuccess_analise: mutation.isSuccess,
    data_abastecimento_ai: mutation?.data
  }
}

export const putAbastecimento = async (data, cod, refetch, setLoadingButton) => {
  loadingAlert({ msg: 'Salvando...', id: 'loading' })
  const config = localConfig()

  api.defaults.headers.Acesso = config.acesso
  const response: AxiosResponse<PropsPost> = await api
    .put(`/abastecimento/${cod}`, data, {
      params: {
        codConta: config.conta,
        codCliente: localConfig().codCliente,
      },
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })

    .then((): any => {
      successAlert('Abastecimento cadastrado com sucesso!', 5000, 'loading')
      setLoadingButton(false)
      refetch()
    })
    .catch((error) => {
      const data = error?.response?.data?.error
      console.log(error)
      const messages = extractMessages(data)

      messages.forEach((msg) => {
        errorAlert(msg, 5000, 'loading')
      })
      setLoadingButton(false)
    })

  return response
}

